@use "shared/assets/styles/abstracts/variables" as v;
@use "shared/assets/styles/abstracts/mixins/typography" as t;
@use "shared/assets/styles/abstracts/mixins/common" as c;

.modal {
  padding: 48px;
  width: 656px;

  @include c.containerMedia(780px) {
    padding: 24px;
    width: calc(100% - 30px);
  }
}

.text {
  @include t.text(20px, 30px, 600);
  color: v.$palette-gray-900;
}
